import { apiRequest, SUPABASE_URL } from "./apiUtils";

const API_BASE_URL = `${SUPABASE_URL}/document-outputs`;

export interface DocumentOutput {
  id: number;
  order_document_id: number;
  processing_state: "unprocessed" | "pending" | "processed";
  output_data?: any;
  processed_at?: string;
  downloaded_at?: string;
  created_at: string;
  updated_at: string;
}

export interface CreateDocumentOutputRequest {
  order_document_id: number;
  output_data: any;
}

export interface UpdateDocumentOutputRequest {
  output_data?: any;
  processing_state?: "pending" | "processed";
  mark_downloaded?: boolean;
}

export const documentOutputApi = {
  // Get document output by order document ID
  getByOrderDocumentId: async (
    orderDocumentId: number
  ): Promise<DocumentOutput | null> => {
    const response = await apiRequest<{ data: DocumentOutput | null }>(
      `${API_BASE_URL}/${orderDocumentId}`
    );
    return response.data;
  },

  // Create a new document output (when starting processing)
  create: async (
    data: CreateDocumentOutputRequest
  ): Promise<DocumentOutput> => {
    const response = await apiRequest<{ data: DocumentOutput }>(API_BASE_URL, {
      method: "POST",
      body: data,
    });
    return response.data;
  },

  // Update document output (when saving changes or finishing processing)
  update: async (
    orderDocumentId: number,
    data: UpdateDocumentOutputRequest
  ): Promise<DocumentOutput> => {
    const response = await apiRequest<{ data: DocumentOutput }>(
      `${API_BASE_URL}/${orderDocumentId}`,
      {
        method: "PUT",
        body: data,
      }
    );
    return response.data;
  },

  // Mark as downloaded (convenience method)
  markAsDownloaded: async (
    orderDocumentId: number
  ): Promise<DocumentOutput> => {
    return documentOutputApi.update(orderDocumentId, {
      mark_downloaded: true,
    });
  },

  // Finish processing (convenience method)
  finishProcessing: async (
    orderDocumentId: number,
    outputData: any
  ): Promise<DocumentOutput> => {
    return documentOutputApi.update(orderDocumentId, {
      output_data: outputData,
      processing_state: "processed",
    });
  },
};
